// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-listing-details {
  font-family: "Proxima Nova", sans-serif;
  height: 100%;
}
.request-listing-details .header {
  padding: 0 24px;
  display: flex;
  height: 60px;
  align-items: center;
  border-bottom: 1px solid #F5F5F5;
  font-weight: 700;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.request-listing-details .body {
  padding: 0 24px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 60px);
}
.request-listing-details .body .subheader {
  font-size: 14px;
  font-weight: 700;
  color: var(--secondary-color-1);
  margin: 0;
}
.request-listing-details .body .close {
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  color: #949494;
  transition: 0.2s ease-in-out;
}
.request-listing-details .body .close:hover {
  color: #FF4267;
}
.request-listing-details .body .showing-details {
  animation: fadeIn 0.5s;
  background-color: white;
  padding: 32px 0;
}
.request-listing-details .body .showing-details .title {
  font-size: 12px;
  font-weight: 700;
  color: var(--secondary-color-1);
  margin: 0;
}
.request-listing-details .body .showing-details > img {
  height: 136px;
  width: 100%;
  object-fit: cover;
  border-radius: 16px;
}
.request-listing-details .body .showing-details .content {
  display: flex;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.request-listing-details .body .showing-details .content > p {
  margin: 0;
}
.request-listing-details .body .showing-details .content .listing-number {
  font-size: 12px;
  font-weight: 700;
  color: #949494;
}
.request-listing-details .body .showing-details .content .listing-name {
  font-size: 14px;
  font-weight: 700;
  color: var(--secondary-color-1);
}
.request-listing-details .body .showing-details .content .listing-address {
  font-size: 12px;
  font-weight: 400;
  color: #5F5F5F;
}
.request-listing-details .body .showing-details .content .listing-amenities {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}
.request-listing-details .body .showing-details .content .listing-amenities .item {
  display: flex;
  column-gap: 8px;
  align-items: center;
}
.request-listing-details .body .showing-details .content .listing-amenities .item > p {
  margin: 0;
  line-height: normal;
  font-size: 12px;
  color: #5F5F5F;
  font-weight: 700;
}
.request-listing-details .body .showing-details .content .listing-price {
  margin: 0;
  font-weight: 700;
  font-size: 18px;
  color: var(--secondary-color-1);
}
.request-listing-details .body .showing-details .content .view-listing {
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  background-color: #FAC91F;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 6px;
}
.request-listing-details .body .showing-details .content .view-listing:hover {
  opacity: 0.75;
}
.request-listing-details .body .showing-details .content .view-listing > p {
  margin: 0;
  font-size: 12px;
  color: white;
  font-weight: 600;
}
.request-listing-details .body .empty {
  font-size: 12px;
  font-weight: 700;
  color: #949494;
  margin: 0;
  padding-top: 8px;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/Calendar/modules/RequestListingtDetails/requestListingtDetails.scss"],"names":[],"mappings":"AAGA;EACI,uCAAA;EACA,YAAA;AAFJ;AAGI;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AADR;AAGI;EACI,eAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,yBAAA;AADR;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAAZ;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;AAAZ;AACY;EACI,cAAA;AAChB;AAEQ;EACI,sBAAA;EACA,uBAAA;EACA,eAAA;AAAZ;AACY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAChB;AACY;EACI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAChB;AACY;EACI,aAAA;EACA,sBAAA;EACA,uCAAA;AAChB;AAAgB;EAAM,SAAA;AAGtB;AAFgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAIpB;AAFgB;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;AAIpB;AAFgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAIpB;AAFgB;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAIpB;AAHoB;EACI,aAAA;EACA,eAAA;EACA,mBAAA;AAKxB;AAJwB;EACI,SAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAM5B;AAFgB;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAIpB;AAFgB;EACI,aAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAIpB;AAHoB;EACI,aAAA;AAKxB;AAHoB;EACI,SAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAKxB;AACQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AACZ;AAEI;EACI;IACI,UAAA;EAAV;EAGM;IACI,UAAA;EADV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n\r\n.request-listing-details {\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    height: 100%;\r\n    .header {\r\n        padding: 0 24px;\r\n        display: flex;\r\n        height: 60px;\r\n        align-items: center;\r\n        border-bottom: 1px solid #F5F5F5;\r\n        font-weight: 700;\r\n        font-size: 16px;\r\n        color: var(--secondary-color-1);\r\n    }\r\n    .body {\r\n        padding: 0 24px;\r\n        padding-bottom: 40px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n        height: calc(100% - 60px);\r\n        .subheader {\r\n            font-size: 14px;\r\n            font-weight: 700;\r\n            color: var(--secondary-color-1);\r\n            margin: 0;\r\n        }\r\n        .close {\r\n            font-size: 10px;\r\n            font-weight: 700;\r\n            cursor: pointer;\r\n            color: #949494;\r\n            transition: .2s ease-in-out;\r\n            &:hover {\r\n                color: #FF4267;\r\n            }\r\n        }\r\n        .showing-details {\r\n            animation: fadeIn .5s;\r\n            background-color: white;\r\n            padding: 32px 0;\r\n            .title {\r\n                font-size: 12px;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-1);\r\n                margin: 0;\r\n            }\r\n            > img {\r\n                height: 136px;\r\n                width: 100%;\r\n                object-fit: cover;\r\n                border-radius: 16px;\r\n            }\r\n            .content {\r\n                display: flex;\r\n                flex-direction: column;\r\n                font-family: 'Proxima Nova', sans-serif;                                             \r\n                > p { margin: 0; }\r\n                .listing-number {\r\n                    font-size: 12px;\r\n                    font-weight: 700;\r\n                    color: #949494;\r\n                }\r\n                .listing-name {\r\n                    font-size: 14px;\r\n                    font-weight: 700;\r\n                    color: var(--secondary-color-1);\r\n                }\r\n                .listing-address {\r\n                    font-size: 12px;\r\n                    font-weight: 400;\r\n                    color: #5F5F5F;\r\n                }\r\n                .listing-amenities {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    row-gap: 20px;\r\n                    .item {\r\n                        display: flex;\r\n                        column-gap: 8px;\r\n                        align-items: center;\r\n                        > p {\r\n                            margin: 0;\r\n                            line-height: normal;\r\n                            font-size: 12px;\r\n                            color: #5F5F5F;\r\n                            font-weight: 700;\r\n                        }\r\n                    }\r\n                }\r\n                .listing-price {\r\n                    margin: 0;\r\n                    font-weight: 700;\r\n                    font-size: 18px;\r\n                    color: var(--secondary-color-1);\r\n                }\r\n                .view-listing {\r\n                    display: flex;\r\n                    height: 32px;\r\n                    justify-content: space-between;\r\n                    align-items: center;\r\n                    background-color: #FAC91F;\r\n                    padding: 6px 12px;\r\n                    cursor: pointer;\r\n                    border-radius: 6px;\r\n                    &:hover {\r\n                        opacity: .75;\r\n                    }\r\n                    > p {\r\n                        margin: 0;\r\n                        font-size: 12px;\r\n                        color: white;\r\n                        font-weight: 600;\r\n                    }\r\n\r\n                }\r\n            }\r\n        }\r\n        .empty {\r\n            font-size: 12px;\r\n            font-weight: 700;\r\n            color: #949494;\r\n            margin: 0;\r\n            padding-top: 8px;\r\n        }\r\n    }\r\n    @keyframes fadeIn {\r\n        0% {\r\n            opacity: 0;\r\n        }\r\n\r\n        100% {\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@include media(tablet) {\r\n    .request-listing-details {\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
